// Import unified stylesheet
import './FormsUnified.css';

// Import all CMS forms
import HomepageFormV2 from './HomepageFormV2';
import HeroSectionForm from './HeroSectionForm';
import QuickAccessForm from './QuickAccessForm';
import QuickLinksForm from './QuicklinksForm';
import HighlightsForm from './HighlightsForm';
import NewsForm from './NewsForm';
import CountdownForm from './CountdownForm';
import AboutUsHeroForm from './AboutUsHeroForm';
import AboutUsPrincipalForm from './AboutUsPrincipalForm';
import AboutUsValuesForm from './AboutUsValuesForm';
import AboutUsVisionMissionValuesForm from './AboutUsVisionMissionValuesForm';
import AboutUsPhilosophyForm from './AboutUsPhilosophyForm';
import AboutUsHistoryForm from './AboutUsHistoryForm';
import AboutUsLeadershipForm from './AboutUsLeadershipForm';
import AboutUsForm from './AboutUsForm';
import EducationForm from './EducationForm';
import EducationProgramHeroForm from './EducationProgramHeroForm';
import EducationProgramLevelsForm from './EducationProgramLevelsForm';
import EducationCurriculumOverviewForm from './EducationCurriculumOverviewForm';
import EducationSubjectsOfferedForm from './EducationSubjectsOfferedForm';
import EducationLearningApproachForm from './EducationLearningApproachForm';
import EducationAssessmentSystemForm from './EducationAssessmentSystemForm';
import EducationSpecialProgramsForm from './EducationSpecialProgramsForm';
import SecondaryPageForm from './SecondaryPageForm';
import AdmissionsForm from './AdmissionsForm';
import AdmissionsHeroForm from './AdmissionsHeroForm';
import AdmissionsLevelsForm from './AdmissionsLevelsForm';
import AdmissionsProcessForm from './AdmissionsProcessForm';
import AdmissionsRequirementsForm from './AdmissionsRequirementsForm';
import AdmissionsKeyDatesForm from './AdmissionsKeyDatesForm';
import AdmissionsFeesPaymentForm from './AdmissionsFeesPaymentForm';
import AdmissionsOnlineApplicationForm from './AdmissionsOnlineApplicationForm';
import StudentLifeForm from './StudentLifeForm';
import StudentLifeHeroForm from './StudentLifeHeroForm';
import StudentLifeClubsForm from './StudentLifeClubsForm';
import StudentLifeEventsForm from './StudentLifeEventsForm';
import StudentLifeHouseSystemForm from './StudentLifeHouseSystemForm';
import StudentLifeHouseDetailsForm from './StudentLifeHouseDetailsForm';
import StudentLifeWellbeingForm from './StudentLifeWellbeingForm';
import StudentLifeCharacterShapingForm from './StudentLifeCharacterShapingForm';
import StudentLifeLeapsForm from './StudentLifeLeapsForm';
import FacilitiesForm from './FacilitiesForm';
import FacilitiesHeroForm from './FacilitiesHeroForm';
import FacilitiesOverviewForm from './FacilitiesOverviewForm';
import FacilitiesOverviewDetailForm from './FacilitiesOverviewDetailForm';
import FacilitiesTechForm from './FacilitiesTechForm';
import FacilitiesTechDetailForm from './FacilitiesTechDetailForm';
import FacilitiesSafetyForm from './FacilitiesSafetyForm';
import FacilitiesGalleryForm from './FacilitiesGalleryForm';
import FacilitiesTourForm from './FacilitiesTourForm';
import NewsUpdatesForm from './NewsUpdatesForm';
import NewsHeroForm from './NewsHeroForm';
import NewsPressForm from './NewsPressForm';
import NewsArticlesForm from './NewsArticlesForm';
import ParentsForm from './ParentsForm';
import ParentsHeroForm from './ParentsHeroForm';
import ParentsLearningCommunityForm from './ParentsLearningCommunityForm';
import ParentsHandbookForm from './ParentsHandbookForm';
import ParentsPortalForm from './ParentsPortalForm';
import ParentsCommunicationForm from './ParentsCommunicationForm';
import CareersForm from './CareersForm';
import CareersHeroForm from './CareersHeroForm';
import CareersPhilosophyForm from './CareersPhilosophyForm';
import CareersPositionsForm from './CareersPositionsForm';
import CareersOpportunitiesForm from './CareersOpportunitiesForm';
import ContactForm from './ContactForm';
import ContactHeroForm from './ContactHeroForm';
import ContactInfoForm from './ContactInfoForm';
import ContactFaqForm from './ContactFaqForm';
import ContactPartnershipsForm from './ContactPartnershipsForm';
import ContactTestimonialsForm from './ContactTestimonialsForm';
import ContactCountdownForm from './ContactCountdownForm';
import FooterForm from './FooterForm';

// Export all forms
export {
  HomepageFormV2 as HomepageForm,
  HeroSectionForm,
  QuickAccessForm,
  QuickLinksForm,
  HighlightsForm,
  NewsForm,
  CountdownForm,
  FooterForm,
  AboutUsHeroForm,
  AboutUsPrincipalForm,
  AboutUsValuesForm,
  AboutUsVisionMissionValuesForm,
  AboutUsPhilosophyForm,
  AboutUsHistoryForm,
  AboutUsLeadershipForm,
  AboutUsForm,
  EducationForm,
  EducationProgramHeroForm,
  EducationProgramLevelsForm,
  EducationCurriculumOverviewForm,
  EducationSubjectsOfferedForm,
  EducationLearningApproachForm,
  EducationAssessmentSystemForm,
  EducationSpecialProgramsForm,
  SecondaryPageForm,
  AdmissionsForm,
  AdmissionsHeroForm,
  AdmissionsLevelsForm,
  AdmissionsProcessForm,
  AdmissionsRequirementsForm,
  AdmissionsKeyDatesForm,
  AdmissionsFeesPaymentForm,
  AdmissionsOnlineApplicationForm,
  StudentLifeForm,
  StudentLifeHeroForm,
  StudentLifeClubsForm,
  StudentLifeEventsForm,
  StudentLifeHouseSystemForm,
  StudentLifeHouseDetailsForm,
  StudentLifeWellbeingForm,
  StudentLifeCharacterShapingForm,
  StudentLifeLeapsForm,
  FacilitiesForm,
  FacilitiesHeroForm,
  FacilitiesOverviewForm,
  FacilitiesOverviewDetailForm,
  FacilitiesTechForm,
  FacilitiesTechDetailForm,
  FacilitiesSafetyForm,
  FacilitiesGalleryForm,
  FacilitiesTourForm,
  NewsUpdatesForm,
  NewsHeroForm,
  NewsPressForm,
  NewsArticlesForm,
  ParentsForm,
  ParentsHeroForm,
  ParentsLearningCommunityForm,
  ParentsHandbookForm,
  ParentsPortalForm,
  ParentsCommunicationForm,
  CareersForm,
  CareersHeroForm,
  CareersPhilosophyForm,
  CareersPositionsForm,
  CareersOpportunitiesForm,
  ContactForm,
  ContactHeroForm,
  ContactInfoForm,
  ContactFaqForm,
  ContactPartnershipsForm,
  ContactTestimonialsForm,
  ContactCountdownForm
};

// Map menu IDs to form components
export const formComponentMap = {
  // Homepage sections
  'homepage': HomepageFormV2,
  'cms-hero': HeroSectionForm,
  'cms-quicklinks': QuickLinksForm,
  'cms-highlights': HighlightsForm,
  'cms-news': NewsForm,
  'cms-countdown': CountdownForm,
  'cms-footer': FooterForm,
  'footer': FooterForm,
  
  // About Us sections
  'about-us': AboutUsForm,
  'cms-about-hero': AboutUsHeroForm,
  'cms-about-principal': AboutUsPrincipalForm,
  'about-us-principal': AboutUsPrincipalForm,
  'about-us:principal': AboutUsPrincipalForm,
  'cms-about-values': AboutUsVisionMissionValuesForm,
  'about-us-values': AboutUsVisionMissionValuesForm,
  'about-us-values-shell': AboutUsVisionMissionValuesForm,
  'about-us:values': AboutUsVisionMissionValuesForm,
  'cms-about-philosophy': AboutUsPhilosophyForm,
  'about-us-philosophy': AboutUsPhilosophyForm,
  'about-us-philosophy-shell': AboutUsPhilosophyForm,
  'about-us:philosophy': AboutUsPhilosophyForm,
  'cms-about-history': AboutUsHistoryForm,
  'about-us-history': AboutUsHistoryForm,
  'about-us-history-shell': AboutUsHistoryForm,
  'about-us:history': AboutUsHistoryForm,
  'cms-about-leadership': AboutUsLeadershipForm,
  
  // Education Program sections
  'education-program': EducationForm,
  'cms-education-hero': EducationProgramHeroForm,
  'cms-edu-programs': EducationProgramLevelsForm,
  'cms-edu-curriculum': EducationCurriculumOverviewForm,
  'cms-edu-subjects': EducationSubjectsOfferedForm,
  'cms-edu-learning': EducationLearningApproachForm,
  'cms-edu-assessment': EducationAssessmentSystemForm,
  'cms-edu-special-programs': EducationSpecialProgramsForm,
  'cms-edu-secondary': SecondaryPageForm,
  'secondary': SecondaryPageForm,
  'secondary-page': SecondaryPageForm,
  
  // Admissions sections (matching database format without cms- prefix)
  'admissions': AdmissionsForm, // Use AdmissionsForm with unified tabs
  'admissions-hero': AdmissionsHeroForm,
  'admissions-levels': AdmissionsLevelsForm,
  'admissions-process': AdmissionsProcessForm,
  'cms-adm-hero': AdmissionsHeroForm,
  'cms-adm-levels': AdmissionsLevelsForm,
  'cms-adm-process': AdmissionsProcessForm,
  'cms-adm-requirements': AdmissionsRequirementsForm,
  'cms-adm-timeline': AdmissionsKeyDatesForm,
  'cms-adm-fees': AdmissionsFeesPaymentForm,
  'cms-adm-online-app': AdmissionsOnlineApplicationForm,
  // Database format (production)
  'admissions-requirements': AdmissionsRequirementsForm,
  'admissions-key-dates': AdmissionsKeyDatesForm,
  'admissions-fees-payment': AdmissionsFeesPaymentForm,
  'admissions-online-application': AdmissionsOnlineApplicationForm,
  
  // Student Life sections (matching DashboardLayout IDs cms-sl-* and database IDs)
  'student-life': StudentLifeForm,
  'cms-sl-hero': StudentLifeHeroForm,
  'cms-sl-clubs': StudentLifeClubsForm,
  'cms-sl-events': StudentLifeEventsForm,
  'cms-sl-houses': StudentLifeHouseSystemForm,
  'cms-sl-house-details': StudentLifeHouseDetailsForm,
  'house-details': StudentLifeHouseDetailsForm,
  'cms-sl-wellbeing': StudentLifeWellbeingForm,
  'cms-sl-character': StudentLifeCharacterShapingForm,
  'cms-sl-leaps': StudentLifeLeapsForm,
  // Backward compatibility aliases
  'cms-life-hero': StudentLifeHeroForm,
  'cms-life-clubs': StudentLifeClubsForm,
  'cms-life-events': StudentLifeEventsForm,
  'cms-life-house-system': StudentLifeHouseSystemForm,
  'cms-life-wellbeing': StudentLifeWellbeingForm,
  'cms-life-character-shaping': StudentLifeCharacterShapingForm,
  'cms-life-leaps': StudentLifeLeapsForm,
  
  // Facilities
  'facilities': FacilitiesForm,
  'cms-fac-hero': FacilitiesHeroForm,
  'cms-fac-overview': FacilitiesOverviewForm,
  'cms-fac-overview-details': FacilitiesOverviewDetailForm,
  'overview-details': FacilitiesOverviewDetailForm,
  'facilities-overview-details': FacilitiesOverviewDetailForm,
  'cms-fac-list': FacilitiesOverviewForm, // backward compatibility
  'cms-fac-tech': FacilitiesTechForm,
  'cms-fac-tech-details': FacilitiesTechDetailForm,
  'tech-details': FacilitiesTechDetailForm,
  'facilities-tech-details': FacilitiesTechDetailForm,
  'cms-fac-safety': FacilitiesSafetyForm,
  'cms-fac-gallery': FacilitiesGalleryForm,
  'cms-fac-tour': FacilitiesTourForm,
  // Database section_type keys
  'facilities-hero': FacilitiesHeroForm,
  'facilities-overview': FacilitiesOverviewForm,
  'facilities-campus-overview': FacilitiesOverviewForm,
  'facilities-technology': FacilitiesTechForm,
  'facilities-safety': FacilitiesSafetyForm,
  'facilities-gallery': FacilitiesGalleryForm,
  'facilities-tour': FacilitiesTourForm,
  
  // News & Updates
  'news-updates': NewsUpdatesForm,
  'cms-news-hero': NewsHeroForm,
  'cms-news-press': NewsPressForm,
  'cms-news-articles': NewsArticlesForm,
  'cms-news-events': NewsPressForm,
  'cms-news-list': NewsArticlesForm,
  'news-hero': NewsHeroForm,
  'news-updates-hero': NewsHeroForm,
  'news-press': NewsPressForm,
  'news-press-releases': NewsPressForm,
  'news-articles': NewsArticlesForm,
  'news-blog-articles': NewsArticlesForm,
  'news-updates:hero': NewsHeroForm,
  'news-updates:press': NewsPressForm,
  'news-updates:articles': NewsArticlesForm,
  
  // Parents
  'parents': ParentsForm,
  'cms-par-hero': ParentsHeroForm,
  'cms-par-palc': ParentsLearningCommunityForm,
  'cms-par-handbook': ParentsHandbookForm,
  'cms-par-portal': ParentsPortalForm,
  'cms-par-communication': ParentsCommunicationForm,
  'cms-par-info': ParentsLearningCommunityForm,
  'cms-par-forms': ParentsHandbookForm,
  'parents-hero': ParentsHeroForm,
  'parents-palc': ParentsLearningCommunityForm,
  'parents-learning-community': ParentsLearningCommunityForm,
  'parents-handbook': ParentsHandbookForm,
  'parent-student-handbook': ParentsHandbookForm,
  'parents-portal': ParentsPortalForm,
  'parent-portal-access': ParentsPortalForm,
  'parents-communication': ParentsCommunicationForm,
  'communication-channels': ParentsCommunicationForm,
  'parents:hero': ParentsHeroForm,
  'parents:palc': ParentsLearningCommunityForm,
  'parents:handbook': ParentsHandbookForm,
  'parents:portal': ParentsPortalForm,
  'parents:communication': ParentsCommunicationForm,
  
  // Careers
  'careers': CareersForm,
  'cms-car-hero': CareersHeroForm,
  'cms-car-philosophy': CareersPhilosophyForm,
  'cms-car-positions': CareersPositionsForm,
  'cms-car-opportunities': CareersOpportunitiesForm,
  'cms-car-openings': CareersPositionsForm,
  'cms-car-culture': CareersPhilosophyForm,
  'careers-hero': CareersHeroForm,
  'careers-philosophy': CareersPhilosophyForm,
  'careers-positions': CareersPositionsForm,
  'careers-open-positions': CareersPositionsForm,
  'careers-opportunities': CareersOpportunitiesForm,
  'careers-internships': CareersOpportunitiesForm,
  'careers:hero': CareersHeroForm,
  'careers:philosophy': CareersPhilosophyForm,
  'careers:positions': CareersPositionsForm,
  'careers:opportunities': CareersOpportunitiesForm,
  
  // Contact Us
  'contact': ContactForm,
  'contact-us': ContactForm,
  'cms-con-hero': ContactHeroForm,
  'cms-con-info': ContactInfoForm,
  'cms-con-location': ContactInfoForm,
  'cms-con-faq': ContactFaqForm,
  'cms-con-partnerships': ContactPartnershipsForm,
  'cms-con-testimonials': ContactTestimonialsForm,
  'cms-con-countdown': ContactCountdownForm,
  'contact-hero': ContactHeroForm,
  'contact-info': ContactInfoForm,
  'contact-location': ContactInfoForm,
  'contact-faq': ContactFaqForm,
  'contact-partnerships': ContactPartnershipsForm,
  'contact-testimonials': ContactTestimonialsForm,
  'contact-countdown': ContactCountdownForm,
  'contact-us:hero': ContactHeroForm,
  'contact-us:info': ContactInfoForm,
  'contact-us:faq': ContactFaqForm,
  'contact-us:partnerships': ContactPartnershipsForm,
  'contact-us:testimonials': ContactTestimonialsForm,
  'contact-us:countdown': ContactCountdownForm,
  
  // Legacy format support (with colon separator)
  'admissions:hero': AdmissionsHeroForm,
  'admissions:levels': AdmissionsLevelsForm,
  'admissions:process': AdmissionsProcessForm,
  'admissions:requirements': AdmissionsRequirementsForm,
  'admissions:timeline': AdmissionsKeyDatesForm,
  'admissions:fees': AdmissionsFeesPaymentForm,
  'admissions:online-app': AdmissionsOnlineApplicationForm,
  'student-life:hero': StudentLifeHeroForm,
  'student-life:clubs': StudentLifeClubsForm,
  'student-life:events': StudentLifeEventsForm,
  'student-life:house-system': StudentLifeHouseSystemForm,
  'student-life:wellbeing': StudentLifeWellbeingForm,
  'student-life:character-shaping': StudentLifeCharacterShapingForm,
  'student-life:leaps': StudentLifeLeapsForm
};

